import React from 'react';

import { FormControlLabel, Switch } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';

const _Switch = ({
    checked,
    disabled,
    label,
    labelPlacement = 'end',
    onChange,
    visible = true,
    ...rest
}) => {
    if (!visible) return null;
    return (
        <FormControlLabel
            control={
                <Switch
                    checked={checked}
                    disabled={disabled}
                    onChange={onChange}
                />
            }
            label={label}
            labelPlacement={labelPlacement}
            {...rest}
        />
    );
};

_Switch.propTypes = {
    checked: PropTypes.bool,
    disabled: PropTypes.bool,
    label: PropTypes.string,
    labelPlacement: PropTypes.string,
    onChange: PropTypes.func,
    visible: PropTypes.bool,
};

export default _Switch;
